import React from "react";
import FriendRequestInput from "../friendRequestInput/FriendRequestInput.js";
import PendingFriendRequests from "../pendingFriendRequests/PendingFriendRequests.js";

const FriendRequestsTabDisplay = ({
  accessToken,
  setDisplayError,
  userData,
}) => {
  return (
    <div className="FriendRequestsTabDisplay">
      <FriendRequestInput
        accessToken={accessToken}
        setDisplayError={setDisplayError}
        userData={userData}
      />
      <PendingFriendRequests
        accessToken={accessToken}
        setDisplayError={setDisplayError}
      />
    </div>
  );
};

export default FriendRequestsTabDisplay;
